<div class="card-base">
    <div class="card-content-reservation-search">
        <div class="chip-container">
            <mat-chip-list>
                <mat-chip color="accent" matTooltip="{{filt.toolTip}}" selected *ngFor="let filt of searchFilters">
                    {{ filt.valueView }}
                    <mat-icon *ngIf="!filt.isRequired" (click)="filt.remove()">cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>
        </div>
        <div class="card-container mat-elevation-z1">
            <div class="clearfix">
                <div class="pull-left div-header-left">
                    <app-search-filter-component #searchFilter (startSearch)="onStartSearch()" (endSearch)="onEndSearch($event)" [filter]="filters"></app-search-filter-component>
                    <app-medical-service-filter #filters></app-medical-service-filter>
                </div>
                <div class="pull-right div-header-right">
                    <button class="card-inline" [matMenuTriggerFor]="columnsMenu" type="button" mat-mini-fab matTooltip="Columnas visibles">
                        <mat-icon>view_column</mat-icon>
                    </button>
                    <button class="card-inline margin-top-medium" matTooltip="Actualizar" (click)="searchFilter.search()" type="button" mat-mini-fab>
                        <mat-icon>autorenew</mat-icon>
                    </button>
                    <mat-menu #columnsMenu="matMenu" class="columns-menu">
                        <button mat-menu-item (click)="showAllColumns()"><span>Mostrar todas</span></button>
                        <mat-divider></mat-divider>
                        <div class="columns-menu-item" *ngFor="let col of availableColumns" (click)="$event.stopPropagation()">
                            <mat-checkbox [checked]="isColumnVisible(col.field)" (click)="$event.stopPropagation()" (change)="setColumnVisibility(col.field, $event.checked)">{{ col.title }}</mat-checkbox>
                        </div>
                    </mat-menu>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="card-content margin-botton-medium">
                <mat-spinner *ngIf="loading"></mat-spinner>
                <div *ngIf="!loading" class="grid-scroll-container">
                    <p-table class="search-table" [value]="dataSource" [tableStyle]="{ width: '100%' }">
                        <ng-template pTemplate="header">
                            <tr class="search-table-header">
                                <th class="resizable-header" *ngFor="let col of orderedColumnsDefinition" [style.width.px]="getColumnWidth(col.field)" (dragover)="onHeaderDragOver($event)" (drop)="onHeaderDrop($event, col.field)">
                                    <div class="header-top-row">
                                        <span class="header-drag-content">
                                            <span class="column-title" (click)="sortByColumn(col.field)">
                                                {{ col.title }}
                                                <mat-icon class="sort-icon">{{ getSortIcon(col.field) }}</mat-icon>
                                            </span>
                                        <mat-icon class="header-drag-handle" draggable="true" (dragstart)="onHeaderDragStart($event, col.field)" (dragend)="onHeaderDragEnd()" (click)="$event.stopPropagation()">drag_indicator</mat-icon>
                                        </span>
                                        <span class="column-resize-handle" (mousedown)="startResize($event, col.field)"></span>
                                    </div>
                                    <input *ngIf="col.field !== 'TrafficLightColor' && col.field !== 'Disability'" class="column-filter-input" [value]="columnFilters[col.field] || ''" (click)="$event.stopPropagation()" (input)="onColumnFilterInput(col.field, $event.target.value)" placeholder="Filtrar"
                                    />
                                </th>
                                <th class="actions-column"></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-element>
                            <tr class="search-table-cell" [ngClass]="{'no-reserved': element.CanStartAttention}" (click)="startAttention(element)">
                                <td *ngFor="let col of orderedColumnsDefinition" [style.width.px]="getColumnWidth(col.field)" [ngSwitch]="col.field">
                                    <ng-container *ngSwitchCase="'TrafficLightColor'">
                                        <div class="traffic-light-color cursor-default" (click)="$event.stopPropagation(); setNextPatientCareTrafficLight(element)" [matTooltip]="getPatientCareTrafficLightCaption(element)" [ngStyle]="{'backgroundColor': getPatientCareTrafficLightHtmlColor(element)}"></div>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'Disability'">
                                        <mat-icon *ngIf="element.DisabilityPermanent || element.DisabilityTemporal">accessible</mat-icon>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'Delay'">
                                        {{ element.ReceptionDate | timedif | async }}
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        {{ formatCellValue(element, col.field) }}
                                    </ng-container>
                                </td>
                                <td class="actions-column" (click)="$event.stopPropagation()">
                                    <mat-spinner *ngIf="element.Loading" [diameter]="15"></mat-spinner>
                                    <button *ngIf="!element.Loading" mat-icon-button [matMenuTriggerFor]="rowMenu">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #rowMenu="matMenu">
                                        <button mat-menu-item (click)="goMedicalOrderScann(element)">
                                            <mat-icon>scanner</mat-icon><span>Ver escaneos</span>
                                        </button>
                                        <button mat-menu-item (click)="openOtherMedicalAppointmentDialogDialog(element)">
                                            <mat-icon>list</mat-icon><span>Ver otros turnos</span>
                                        </button>
                                        <button mat-menu-item (click)="openMedicalAppointmentObservationDialog(element)">
                                            <mat-icon>search</mat-icon><span>Ver observaciones</span>
                                        </button>
                                        <button mat-menu-item (click)="openPhysicianReplacementDialog(element)">
                                            <mat-icon>compare_arrows</mat-icon><span>Cambiar médico</span>
                                        </button>
                                        <button mat-menu-item (click)="openEquipmentReplacementDialog(element)">
                                            <mat-icon>compare_arrows</mat-icon><span>Cambiar equipo</span>
                                        </button>
                                        <button *ngIf="element.ReservationRequestHisId" mat-menu-item (click)="openReservationHisRequestDialog(element)">
                                            <mat-icon>search</mat-icon><span>Ver solicitud HIS</span>
                                        </button>
                                        <button mat-menu-item (click)="view(element)">
                                            <mat-icon>search</mat-icon><span>Ver</span>
                                        </button>
                                        <button *ngIf="canStartAttention(element)" mat-menu-item (click)="startAttention(element)">
                                            <mat-icon>flag</mat-icon><span>Iniciar atención</span>
                                        </button>
                                        <button *ngIf="element.CanRollBack" mat-menu-item (click)="rollBackAttention(element)">
                                            <mat-icon>undo</mat-icon><span>Revertir</span>
                                        </button>
                                        <button mat-menu-item (click)="patientCall(element)">
                                            <mat-icon>notifications</mat-icon><span>{{ getPatientCallButtonText(element) }}</span>
                                        </button>
                                    </mat-menu>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                <pager (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>
            </div>
        </div>
    </div>
</div>
